var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("PortalWidget", { attrs: { widget: _vm.widget } }, [
    !_vm.isLoading
      ? _c(
          "div",
          [
            _c("ValidationObserver", {
              ref: "form",
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function({ handleSubmit, invalid }) {
                      return [
                        _c(
                          "form",
                          {
                            staticClass: "form-horizontal",
                            attrs: { novalidate: "" },
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                                return handleSubmit(_vm.createUpdateAccount)
                              }
                            }
                          },
                          [
                            _c("fieldset", [
                              _c("div", { staticClass: "container-fluid" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "col-sm-3 col-md-3 control-label"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("ACCOUNT_PAGE_COUNTRY")
                                          ) +
                                          "\n                "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value: _vm.$t(
                                                "ACCOUNT_PAGE_COUNTRY_TT"
                                              ),
                                              expression:
                                                "$t('ACCOUNT_PAGE_COUNTRY_TT')"
                                            }
                                          ],
                                          staticClass: "tooltip-icon"
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa m-l-3 fa-question-circle"
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-4 col-md-3" },
                                    [
                                      _c("CountrySelector", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "ACCOUNT_PAGE_COUNTRY_DEFAULT"
                                          )
                                        },
                                        on: { change: _vm.onCountryChange },
                                        model: {
                                          value: _vm.countryValue,
                                          callback: function($$v) {
                                            _vm.countryValue = $$v
                                          },
                                          expression: "countryValue"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "col-sm-3 col-md-3 control-label"
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("ACCOUNT_PAGE_TIME_ZONE")
                                            ) +
                                            "\n                "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: _vm.$t(
                                                  "ACCOUNT_PAGE_TIME_ZONE_TT"
                                                ),
                                                expression:
                                                  "$t('ACCOUNT_PAGE_TIME_ZONE_TT')"
                                              }
                                            ],
                                            staticClass: "tooltip-icon"
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa m-l-3 fa-question-circle"
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        rules: "required",
                                        name: "Time Zone"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ classes, errors }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-sm-4 col-md-3",
                                                    class: classes
                                                  },
                                                  [
                                                    _c("SearchableDropdown", {
                                                      attrs: {
                                                        config:
                                                          _vm.timeZoneOptions,
                                                        "data-testid":
                                                          "timezone-dropdown",
                                                        placeholder: _vm.$t(
                                                          "ACCOUNT_PAGE_TIME_ZONE_TT"
                                                        )
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.localAccountInfo
                                                            .timeZoneId,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.localAccountInfo,
                                                            "timeZoneId",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "localAccountInfo.timeZoneId"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "col-sm-3 col-md-3 control-label"
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("ACCOUNT_PAGE_COMPANY")
                                            ) +
                                            "\n                "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: _vm.$t(
                                                  "ACCOUNT_PAGE_COMPANY_TT"
                                                ),
                                                expression:
                                                  "$t('ACCOUNT_PAGE_COMPANY_TT')"
                                              }
                                            ],
                                            staticClass: "tooltip-icon"
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa m-l-3 fa-question-circle"
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        rules: "required",
                                        name: "Company"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors, classes }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-sm-4 col-md-3",
                                                    class: classes
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.localAccountInfo
                                                              .name,
                                                          expression:
                                                            "localAccountInfo.name"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      attrs: { type: "text" },
                                                      domProps: {
                                                        value:
                                                          _vm.localAccountInfo
                                                            .name
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            _vm.localAccountInfo,
                                                            "name",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "col-sm-3 col-md-3 control-label"
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("ACCOUNT_PAGE_ADDRESS")
                                            ) +
                                            "\n                "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: _vm.$t(
                                                  "ACCOUNT_PAGE_ADDRESS_TT"
                                                ),
                                                expression:
                                                  "$t('ACCOUNT_PAGE_ADDRESS_TT')"
                                              }
                                            ],
                                            staticClass: "tooltip-icon"
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa m-l-3 fa-question-circle"
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        rules: "required",
                                        name: "Address"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors, classes }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-sm-4 col-md-3",
                                                    class: classes
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.localAccountInfo
                                                              .accountAddress
                                                              .streetAddress,
                                                          expression:
                                                            "localAccountInfo.accountAddress.streetAddress"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        type: "text",
                                                        "data-testid":
                                                          "account-address-input"
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.localAccountInfo
                                                            .accountAddress
                                                            .streetAddress
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            _vm.localAccountInfo
                                                              .accountAddress,
                                                            "streetAddress",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", {
                                    staticClass:
                                      "col-sm-3 col-md-3 control-label"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-4 col-md-3" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.localAccountInfo
                                                .accountAddress.addressLine2,
                                            expression:
                                              "localAccountInfo.accountAddress.addressLine2"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          placeholder: _vm.$t(
                                            "ACCOUNT_PAGE_ADDRESS_TWO_DEFAULT"
                                          )
                                        },
                                        domProps: {
                                          value:
                                            _vm.localAccountInfo.accountAddress
                                              .addressLine2
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.localAccountInfo
                                                .accountAddress,
                                              "addressLine2",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "col-sm-3 col-md-3 control-label"
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("ACCOUNT_PAGE_CITY")
                                            ) +
                                            "\n                "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: _vm.$t(
                                                  "ACCOUNT_PAGE_CITY_TT"
                                                ),
                                                expression:
                                                  "$t('ACCOUNT_PAGE_CITY_TT')"
                                              }
                                            ],
                                            staticClass: "tooltip-icon"
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa m-l-3 fa-question-circle"
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        rules: "required",
                                        name: "City"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors, classes }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-sm-4 col-md-3",
                                                    class: classes
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.localAccountInfo
                                                              .accountAddress
                                                              .city,
                                                          expression:
                                                            "localAccountInfo.accountAddress.city"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      attrs: { type: "text" },
                                                      domProps: {
                                                        value:
                                                          _vm.localAccountInfo
                                                            .accountAddress.city
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            _vm.localAccountInfo
                                                              .accountAddress,
                                                            "city",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "col-sm-3 col-md-3 control-label"
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("ACCOUNT_PAGE_STATE")
                                            ) +
                                            "\n                "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: _vm.$t(
                                                  "ACCOUNT_PAGE_STATE_TT"
                                                ),
                                                expression:
                                                  "$t('ACCOUNT_PAGE_STATE_TT')"
                                              }
                                            ],
                                            staticClass: "tooltip-icon"
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa m-l-3 fa-question-circle"
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        rules: "required",
                                        name: "State"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors, classes }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-sm-4 col-md-3",
                                                    class: classes
                                                  },
                                                  [
                                                    _vm.countryValue.value ===
                                                    "US"
                                                      ? _c(
                                                          "SearchableDropdown",
                                                          {
                                                            attrs: {
                                                              config:
                                                                _vm.stateOptions,
                                                              "data-testId":
                                                                "account-state-dropdown",
                                                              placeholder: _vm.$t(
                                                                "ACCOUNT_PAGE_STATE_DEFAULT"
                                                              )
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .localAccountInfo
                                                                  .accountAddress
                                                                  .region,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm
                                                                    .localAccountInfo
                                                                    .accountAddress,
                                                                  "region",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "localAccountInfo.accountAddress.region"
                                                            }
                                                          }
                                                        )
                                                      : _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm
                                                                  .localAccountInfo
                                                                  .accountAddress
                                                                  .region,
                                                              expression:
                                                                "localAccountInfo.accountAddress.region"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            type: "text"
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm
                                                                .localAccountInfo
                                                                .accountAddress
                                                                .region
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              )
                                                                return
                                                              _vm.$set(
                                                                _vm
                                                                  .localAccountInfo
                                                                  .accountAddress,
                                                                "region",
                                                                $event.target
                                                                  .value
                                                              )
                                                            }
                                                          }
                                                        }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "col-sm-4 col-md-3 control-label"
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("ACCOUNT_PAGE_ZIP")) +
                                            "\n                "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: _vm.$t(
                                                  "ACCOUNT_PAGE_ZIP_TT"
                                                ),
                                                expression:
                                                  "$t('ACCOUNT_PAGE_ZIP_TT')"
                                              }
                                            ],
                                            staticClass: "tooltip-icon"
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa m-l-3 fa-question-circle"
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("ValidationProvider", {
                                      attrs: { rules: "required", name: "Zip" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors, classes }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-sm-3 col-md-3",
                                                    class: classes
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.localAccountInfo
                                                              .accountAddress
                                                              .postalCode,
                                                          expression:
                                                            "localAccountInfo.accountAddress.postalCode"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        type: "text",
                                                        maxlength: "8"
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.localAccountInfo
                                                            .accountAddress
                                                            .postalCode
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            _vm.localAccountInfo
                                                              .accountAddress,
                                                            "postalCode",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-sm-9 col-md-9 col-md-offset-3 col-sm-offset-3"
                                    },
                                    [
                                      _vm.triedToSend && invalid
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "m-t-8 m-b-8 bright-red"
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "f-s-20 p-r-0 typcn typcn-warning"
                                              }),
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "FORM_VALIDATION_ERROR"
                                                  )
                                                ) + "\n                "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "PrimaryButton",
                                        {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value: {
                                                content: _vm.$t(
                                                  "ACCOUNT_PAGE_COUNTRY_TT"
                                                ),
                                                hideDelay: 0,
                                                showDelay: 0
                                              },
                                              expression:
                                                "{ content: $t('ACCOUNT_PAGE_COUNTRY_TT'), hideDelay: 0, showDelay: 0 }"
                                            }
                                          ],
                                          attrs: {
                                            type: "submit",
                                            "size-class": "btn-lg",
                                            "show-loader-on-form":
                                              _vm.isUpdating
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.triedToSend = true
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "ACCOUNT_PAGE_UPDATE_BUTTON"
                                                )
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                1936483131
              )
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isLoading
      ? _c(
          "div",
          { staticClass: "text-center empty-records" },
          [
            _c("Loader"),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "ACCOUNT_DETAILS_LOADING",
                  expression: "'ACCOUNT_DETAILS_LOADING'"
                }
              ]
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }